import { render, staticRenderFns } from "./TextLabel.vue?vue&type=template&id=4811712e&scoped=true&"
import script from "./TextLabel.vue?vue&type=script&lang=js&"
export * from "./TextLabel.vue?vue&type=script&lang=js&"
import style0 from "./TextLabel.vue?vue&type=style&index=0&id=4811712e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4811712e",
  null
  
)

export default component.exports